// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.Modal_modal__yEgVW {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  height: 100%;
  width: 100%;
  inset: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Modal_modal__yEgVW .Modal_box__3CnXA {
  width: 55vw;
  background: #FFFFFF;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  max-height: 665px;
  overflow-y: scroll;
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/components/Modal/Modal.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,8BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAYF;AAVE;EACE,WAAA;EACA,mBDYI;ECXJ,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAYJ","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import '../../core/styles';\n\n.modal {\n  background: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .box {\n    width: 55vw;\n    background: $white;\n    box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.18);\n    border-radius: 8px;\n    max-height: 665px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__yEgVW`,
	"box": `Modal_box__3CnXA`
};
export default ___CSS_LOADER_EXPORT___;
